import { BadgeLabel, Pointer } from '@yleisradio/areena-types';
import useSWR from 'swr';
import { useTunnusContext } from 'contexts/TunnusContext';
import { getBadge } from 'services/areena-api/fetchers';

type Key = string | null;
type Fetcher = (key: Key) => Promise<BadgeLabel | null>;

const fetcher: Fetcher = async (badgeSourceUri) => {
  if (!badgeSourceUri) return null;

  return await getBadge(badgeSourceUri);
};

export function useBadge(badgeSource: Pointer | undefined): BadgeLabel | null {
  const { isAuthenticated } = useTunnusContext();
  const key: Key = badgeSource && isAuthenticated ? badgeSource.uri : null;
  const { data } = useSWR(key, fetcher);
  return data || null;
}
